document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('contact_form');

    if (!form) return;

    const sectionId = form.getAttribute('data-section-id');
    const roleRadioButtons = form.querySelectorAll(`input[type="radio"][name="contact[role]"]`);
    const hiddenTagsInput = document.getElementById('hidden-tags-input');

    form.addEventListener('submit', () => {
        roleRadioButtons.forEach((radioButton) => {
            if (radioButton.checked) {
                hiddenTagsInput.value += `, ${radioButton.value}`;
            }
        });

        return true;
    });
});
